var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "process-body"
  }, [_c('HubHeader', {
    attrs: {
      "fixed": false
    }
  }), _c('nav', {
    staticClass: "process-nav"
  }, [_vm._m(0), _c('ul', {
    staticClass: "process-list"
  }, [_c('li', {
    staticClass: "gate",
    attrs: {
      "data-selected": _vm.editorType == 'gate' || _vm.editorType == 'gate' ? true : false
    }
  }, [_c('button', {
    on: {
      "click": _vm.moveToGate
    }
  }, [_c('small', [_vm._v("공정도목록")])])]), _vm.pageType == _vm.pageTypeList[0] ? _c('div', [_c('li', {
    staticClass: "protocol",
    attrs: {
      "data-selected": _vm.$route.query.menuType == 'researcher' ? true : false
    }
  }, [_c('button', {
    on: {
      "click": function ($event) {
        return _vm.clickEditorTabHandler('experiment');
      }
    }
  }, [_vm._v("실험입력")])]), _vm.user && (_vm.user.admin || _vm.user.committee || _vm.user.super || _vm.user.generalManager) ? _c('li', {
    staticClass: "process",
    attrs: {
      "data-selected": _vm.$route.query.menuType == 'manager' ? true : false
    }
  }, [_c('button', {
    on: {
      "click": function ($event) {
        return _vm.clickEditorTabHandler('process');
      }
    }
  }, [_vm._v("공정도")])]) : _vm._e()]) : _vm._e(), _vm.pageType == _vm.pageTypeList[1] ? _c('div', [_c('li', {
    staticClass: "visualization",
    attrs: {
      "data-selected": _vm.$route.query.menuType == 'manager' ? true : false
    }
  }, [_c('button', {
    on: {
      "click": function ($event) {
        return _vm.clickEditorTabHandler('visualization');
      }
    }
  }, [_vm._v("시각화")])])]) : _vm._e()])]), _c('router-view', {
    key: _vm.$route.fullPath
  }), _c('registDictionaryPopup', {
    key: _vm.registDictionaryPopupKey,
    attrs: {
      "forceReRender": _vm.registDictionaryPopupKey
    },
    on: {
      "update:forceReRender": function ($event) {
        _vm.registDictionaryPopupKey = $event;
      },
      "update:force-re-render": function ($event) {
        _vm.registDictionaryPopupKey = $event;
      }
    }
  }), _c('ExperimentType'), _c('EditAttribute'), _c('EditAttributePool'), _c('ConnectProtocol'), _c('SearchProtocol'), _c('ProtocolDetail'), _c('FileUpload'), _c('ResultConfirm'), _c('SaveHistory'), _c('VersionHistory'), _c('VisualizationPopup'), _c('KeshImageService'), _c('TagOptionPopTagAddList')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_c('span', [_vm._v("HUB")]), _vm._v(" "), _c('span', [_vm._v("EDITOR")])]);

}]

export { render, staticRenderFns }